import { CommonModule } from '@angular/common';
import { Component, Inject, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { AlertService } from '../../services/alert.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { RegionService } from '../../services/region.service';
import { MdlNewTaskComponent } from '../mdl-new-task/mdl-new-task';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mdl-convert-prospect',
  imports: [CommonModule, FormsModule, NgSelectModule],
  templateUrl: './mdl-convert-prospect.html',
  styleUrl: './mdl-convert-prospect.css',
})
export class MdlConvertProspect implements OnInit {
  public step: number = 1;

  public comunas: string [] = [];
  public industrias: any = [];
  public loggedUserName: string = '';
  public accounts: any = [];
  public contacts: any = [];
  public opportunities: any = [];
  public prospecto: any = [];

  public selectedAccount: string = '';
  public selectedContact: string = '';
  public selectedOpportunity: string = '';

  private api = inject(Api);
  private regionService = inject(RegionService); 

  public regiones: { NombreRegion: string }[] = [];
  public comunasFact: string[] = []; 
  public comunasEnv: string[] = []; 

  public cuenta: any = [];

  propietarioContacto: string = '';
  public contacto: any = {};
  public estados: any = [];
  public opp_estados: any = [];
  public today: string = '';
  oportunidadSeleccionada: any = null;

  public accountType: string = 'new';
  public contactType: string = 'new';
  public opportunityType: string = 'new';
  public contactoExistente: string = '';
  public oportunidadExistente: string = '';

  public cuentaExistente: string = '';

  public request: any = {
    nombre_cuenta: '',
    estado: '',

    nueva_cuenta_nombre: '',
    cuenta_id: '',

    nuevo_contacto_tratamiento: '',
    nuevo_contacto_nombre: '',
    nuevo_contacto_apellido: '',
    contacto_id: '',

    nueva_oportunidad_nombre: '',
    oportunidad_id: '',
  };

  cuentas: any[] = [];
  public cuentaSeleccionada: any = null;

  public acc_request: any = {
    cuenta_id: "",
    nombre_empresa: "",
    rut: "",
    industria_id: "",
    telefono: "",
    sitio_web: "",
    subfamilia: "",
    divisa_cuenta: "",
    ejecutivo_id: "",
    empleados: "",
    linkedin: "",
    descripcion: "",
    direccion_fact: "",
    calle_fact: "",
    ciudad_fact: "",
    region_fact: "",
    pais_fact: "Chile", 
    direccion_env: "",
    calle_env: "",
    ciudad_env: "",
    region_env: "",
    pais_env: "Chile" 
  }

  public cnt_request: any = {
      cuenta_id: "",
      contacto_id: "",
      nombre: "",
      apellido: "",
      tratamiento: "",
      cargo: "",
      telefono: "",
      celular: "",
      email: "",
      linkedin: "",
      fecha_nacimiento: "",
      aniversario_empresa: "",
      hobbie: "",
      identidad_genero: "",
      calle_env: "",
      ciudad_env: "",
      region_env: "",
      pais: "Chile",
      estado: 0,
      funcion: "",
      observaciones: ""
  };

  public opp_request: any = {
    nombre: '',
    cuenta_id: '',
    tipo_negocio: '',
    id_estado: '',
    importe_antes:0 ,
    importe_actual:0,
    fecha_cierre: '',
    probabilidad_cierre: '',
    sgte_paso: '',
    propietario: 'Juan Soto', 
    categoria_prevision: '',
    tipo_oportunidad: '',
    motivo_perdida: '',
    descripcion: '',
    contrato: '',
    presupuesto: '',
    tipo_empresa: '',
    fuente_lead: '',
    notas: '' ,
    estado: '',
    privada_publica:'',
    presupuesto_sincronizado: '',
    marcado: 0,
  };
  private alertService = inject(AlertService);
  readonly dialog = inject(MatDialog);

  constructor(
    public mdl: MatDialogRef<MdlConvertProspect>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.prospecto = this.data.prospecto;
    this.getOpportunityStatus();

    this.regiones = this.regionService.getRegionesFull();
    this.getAccounts();
    this.getContacts();
    this.getOpportunities();
    this.getIndustrias();

    
    this.getComunas(this.prospecto.region || '');
    this.formatProspectAccount();
    console.log(this.prospecto);
  }

  closeMdl() {
    this.mdl.close();
  }
  
  nextStep(){
    this.step += 1;
  }

  getAccounts() {
    this.api.getAccounts().subscribe({
      next: (data: any) => {
        this.accounts = data.cuentas;
        console.log(this.accounts);
      },
      error: (error: any) => {
        console.error(error);
      },
    });
  }

  getContacts() {
    this.api.getContacts().subscribe({
      next: (data: any) => {
        this.contacts = data.contactos;
        this.contacts = this.contacts.map((contact: any) => ({
          ...contact,
          fullName: `${contact.nombre || 'Sin nombre'} ${contact.apellido || 'Sin apellido'}`
        }));
        console.log('Contactos cargados:', this.contacts.length);
      },
      error: (error: any) => {
        console.error('Error al cargar contactos:', error);
      },
    });
  }

  getOpportunities() {
    this.api.getOpportunities().subscribe({
      next: (data: any) => {
        this.opportunities = data.oportunidades;
        console.log('Oportunidades cargadas:', this.opportunities.length);
      },
      error: (error: any) => {
        console.error('Error al cargar oportunidades:', error);
      },
    });
  }

  getIndustrias() {
    this.api.getIndustrias().subscribe({
      next: (data: any) => {
        this.industrias = data.data;
        console.log(this.industrias);
      },
      error: (error: any) => {
        console.error(error);
      },
    });
  }

  getComunasFact(region: string) {
    this.comunasFact = this.regionService.getComunasByRegion(region);
    if (this.comunasFact.length > 0 && !this.request.ciudad_fact) {
      this.request.ciudad_fact = this.comunasFact[0];
    }
  }

  getComunasEnv(region: string) {
    this.comunasEnv = this.regionService.getComunasByRegion(region);
    if (this.comunasEnv.length > 0 && !this.request.ciudad_env) {
      this.request.ciudad_env = this.comunasEnv[0];
    }
  }

  createAccount(){
    this.api.showLoading();
    try {
      const rutRegex = /^(\d{1,2}\.?\d{3}\.?\d{3}-[\dkK])$/;
      const phoneRegex = /^\+?\d{0,15}$/;

      if (!rutRegex.test(this.request.rut)) {
        console.log("RUT invalido:", this.request.rut);
           this.alertService.error('Error de validación', 'El formato del RUT es inválido');
        return;
      }
      if (this.request.telefono && !phoneRegex.test(this.request.telefono)) {
      setTimeout(() => {
        console.log("Telefono invalido:", this.request.telefono);
            this.alertService.error('Error de validación', 'Formato de teléfono no aceptado');
      }, 0);
          return;
      }
      this.api.createAccount(this.request).subscribe({
        next: (data:any) =>{
          setTimeout(() => {
            this.api.hideLoading();
            this.alertService.success('Éxito', 'Cuenta creada exitosamente');
            window.location.reload();
          }, 500);
        },
        error: (err: any) =>{
          console.error(err);
        }
      })
    } catch (error) {
      console.error(error);
    }
  }

  updateAccount(){
    this.api.showLoading();
    try {
      this.api.updateAccount(this.request).subscribe({
      next: (data:any) =>{
        setTimeout(() => {
          this.api.hideLoading();
          window.location.reload();
        }, 500);
      },
      error: (err: any) =>{
        console.error(err);
      }
    })
    } catch (error) {
      console.error(error);
    }
  }


  actualizarPropietario(cuenta_id: string){
    const cuenta = this.accounts.find((c: any) => c.cuenta_id === cuenta_id);
    const ejecutivo = cuenta?.ejecutivo;
    this.propietarioContacto = ejecutivo
        ? `${ejecutivo.nombre} ${ejecutivo.apellido}`
        : 'Sin propietario';
  }

  getComunas(region:string){
    this.comunas = this.regionService.getComunasByRegion(region);
    console.log(region);
    console.log(this.comunas);
    if (!this.request.ciudad_env) {
      this.request.ciudad_env = this.comunas[0];
    }
  }

  getOpportunityStatus(){
    this.api.getStatusByType({tipo:'OPP'}).subscribe({
      next: (data:any)=>{
        this.opp_estados = data.data;
        console.log(this.opp_estados);
      },
      error: (err:any)=>{
        console.error(err);
      }
    })
  }

  formatProspectAccount(){
    this.acc_request.nombre_empresa = this.prospecto.empresa || '';
    this.acc_request.telefono = this.prospecto.telefono || '';
    this.acc_request.sitio_web = this.prospecto.sitio_web || '';
    this.acc_request.industria_id = this.prospecto.industria_id || '';
    this.acc_request.ejecutivo_id = this.prospecto.ejecutivo_id || '';
    this.acc_request.empleados = this.prospecto.empleados || '';
    
    this.acc_request.direccion_fact = this.prospecto.direccion || '';
    this.acc_request.calle_fact = this.prospecto.calle || '';
    this.acc_request.ciudad_fact = this.prospecto.ciudad || '';
    this.acc_request.region_fact = this.prospecto.region || '';
    this.acc_request.pais_fact = this.prospecto.pais || 'Chile';
    
    this.acc_request.direccion_env = this.prospecto.direccion || '';
    this.acc_request.calle_env = this.prospecto.calle || '';
    this.acc_request.ciudad_env = this.prospecto.ciudad || '';
    this.acc_request.region_env = this.prospecto.region || '';
    this.acc_request.pais_env = this.prospecto.pais || 'Chile';

    this.cnt_request.nombre = this.prospecto.nombre || '';
    this.cnt_request.apellido = this.prospecto.apellido || '';
    this.cnt_request.cargo = this.prospecto.cargo || '';
    this.cnt_request.telefono = this.prospecto.telefono || '';
    this.cnt_request.celular = this.prospecto.celular || '';
    this.cnt_request.email = this.prospecto.email || '';
    
    this.cnt_request.calle_env = this.prospecto.calle || '';
    this.cnt_request.ciudad_env = this.prospecto.ciudad || '';
    this.cnt_request.region_env = this.prospecto.region || '';
    this.cnt_request.pais = this.prospecto.pais || 'Chile';

    this.opp_request.nombre = `Oportunidad - ${this.prospecto.empresa || this.prospecto.nombre}` || '';
    this.opp_request.fuente_lead = this.prospecto.origen || '';
    this.opp_request.propietario = this.prospecto.ejecutivo_id || '';
    
    if (this.prospecto.ejecutivo) {
      this.opp_request.propietario = `${this.prospecto.ejecutivo.nombre} ${this.prospecto.ejecutivo.apellido}`;
    }
  }

  updateContact() {
      this.api.showLoading();
      try{
          this.api.updateContact(this.request).subscribe({
              next:(data:any) =>{
                  setTimeout(() => {
                      this.api.hideLoading();
                      window.location.reload();
                  }, 500);
      },
      error: (err:any) => {
          console.error(err);
      }
          })
      } catch (err) {
          console.error(err);
      }
  }

  createContact() {
    this.request.cuenta_id = this.cuentaSeleccionada;
    this.api.showLoading();
    try {
        this.api.createContact(this.request).subscribe({
            next: (data:any) => {
                setTimeout(() => {
                    this.api.hideLoading();
                    window.location.reload();
                }, 500);
            },
            error: (error:any) => {
                console.error(error);
            }
        });
    } catch (err) {
        console.error(err);
    }
  }

  updateOpportunity() {
    this.api.showLoading();
    try{
      this.api.updateOpportunity(this.request).subscribe({
        next:(data:any) =>{
            setTimeout(() => {
                this.api.hideLoading();
                window.location.reload();
            }, 500);
        },
        error: (err:any) => {
            console.error(err);
        }
      });
    } catch (err) {
        console.error(err);
    }
  }

  createOpportunity(){
    this.request.oportunidad_id = this.oportunidadSeleccionada;
    this.request.cuenta_id = this.selectedAccount;
    this.api.showLoading();
    try {
      this.api.createOpportunity(this.request).subscribe({
        next: (data:any) => {
            setTimeout(() => {
                this.api.hideLoading();
                window.location.reload();
            }, 500);
        },
        error: (error:any) => {
            console.error(error);
        }
      });
    } catch (err) {
        console.error(err);
    }
  }

  convertProspect() {
    this.api.showLoading();
    
    if (this.accountType === 'new' && !this.acc_request.nombre_empresa) {
      this.alertService.error('Error de validación', 'El nombre de la empresa es requerido');
      this.api.hideLoading();
      return;
    }

    if (this.accountType === 'existing' && !this.cuentaExistente) {
      this.alertService.error('Error de validación', 'Debe seleccionar una cuenta existente');
      this.api.hideLoading();
      return;
    }

    if (this.contactType === 'new' && (!this.cnt_request.nombre || !this.cnt_request.apellido)) {
      this.alertService.error('Error de validación', 'El nombre y apellido del contacto son requeridos');
      this.api.hideLoading();
      return;
    }

    if (this.contactType === 'existing' && !this.contactoExistente) {
      this.alertService.error('Error de validación', 'Debe seleccionar un contacto existente');
      this.api.hideLoading();
      return;
    }

    console.log('Iniciando conversión de prospecto...');
    
    if (this.accountType === 'existing') {
      const cuentaId = this.cuentaExistente;
      this.handleContactCreation(cuentaId);
    } else {
      this.api.createAccount(this.acc_request).subscribe({
        next: (accountResponse: any) => {
          console.log('Cuenta creada:', accountResponse);
          
          if (accountResponse?.cuenta) {
            const cuentaId = accountResponse.cuenta.cuenta_id;
            this.handleContactCreation(cuentaId);
          } else {
            this.api.hideLoading();
            this.alertService.error('Error', 'No se recibió la información de la cuenta creada');
          }
        },
        error: (accountError: any) => {
          console.error('Error creando cuenta:', accountError);
          this.api.hideLoading();
          this.alertService.error('Error', 'Error al crear la cuenta');
        }
      });
    }
  }

  handleContactCreation(cuentaId: string) {
    if (this.contactType === 'existing') {
      if (this.contactoExistente) {
        console.log('Contacto existente seleccionado:', this.contactoExistente);
        this.handleOpportunityCreation(cuentaId);
      } else {
        this.api.hideLoading();
        this.alertService.error('Error de validación', 'Debe seleccionar un contacto existente');
      }
    } else {
      this.cnt_request.cuenta_id = cuentaId;
      
      this.api.createContact(this.cnt_request).subscribe({
        next: (contactResponse: any) => {
          console.log('Contacto creado:', contactResponse);
          this.handleOpportunityCreation(cuentaId);
        },
        error: (contactError: any) => {
          console.error('Error creando contacto:', contactError);
          this.api.hideLoading();
          this.alertService.error('Error', 'Error al crear el contacto');
        }
      });
    }
  }

  handleOpportunityCreation(cuentaId: string) {
    const contactMessage = this.contactType === 'existing' ? 'contacto existente' : 'nuevo contacto';
    
    switch (this.opportunityType) {
      case 'new':
        this.opp_request.cuenta_id = cuentaId;
        
        this.api.createOpportunity(this.opp_request).subscribe({
          next: (opportunityResponse: any) => {
            console.log('Oportunidad creada:', opportunityResponse);
            this.finishConversion(`Prospecto convertido exitosamente con ${contactMessage} y nueva oportunidad`);
          },
          error: (oppError: any) => {
            console.error('Error creando oportunidad:', oppError);
            this.api.hideLoading();
            this.alertService.error('Error', 'Error al crear la oportunidad');
          }
        });
        break;

      case 'existing':
        if (this.oportunidadExistente) {
          console.log('Oportunidad existente seleccionada:', this.oportunidadExistente);
          this.finishConversion(`Prospecto convertido exitosamente con ${contactMessage} y oportunidad existente`);
        } else {
          this.finishConversion(`Prospecto convertido exitosamente con ${contactMessage} sin oportunidad vinculada`);
        }
        break;

      case 'none':
        console.log('No se creará oportunidad');
        this.finishConversion(`Prospecto convertido exitosamente con ${contactMessage} sin oportunidad`);
        break;

      default:
        this.finishConversion(`Prospecto convertido exitosamente con ${contactMessage}`);
        break;
    }
  }

  finishConversion(message: string) {
    setTimeout(() => {
      this.api.hideLoading();
      this.alertService.success('Éxito', message);
      this.step = 4;
    }, 500);
  }

  openCreateTaskMdl() {
    this.mdl.close();
    const dialogRef = this.dialog.open(MdlNewTaskComponent, {
      width: '600px',
      data: {
        prospecto: this.prospecto
      }
    });
  }

  goToProspectsPage() {
    this.mdl.close();
    this.router.navigate(['/prospects']);
  }
}
